interface Iprops {
  width: number;
  height: number;
}

export const LogoIcon = ({ width, height }: Iprops) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8838 12.8159C23.334 11.8428 23.5859 10.7591 23.5859 9.61744C23.5859 5.41718 20.1827 2 15.9996 2L12.9523 2V4.79282L15.9996 4.79282C18.649 4.79282 20.8044 6.95715 20.8044 9.61744C20.8044 12.2778 18.649 14.4422 15.9996 14.4422C13.3502 14.4422 11.1947 12.2778 11.1947 9.61744V2.00125L8.41333 2.00125L8.41333 9.61744C8.41333 10.7591 8.66523 11.8428 9.11545 12.8159C5.25392 13.1664 2.21777 16.4345 2.21777 20.4016C2.21777 24.602 5.62103 28.0192 9.80406 28.0192H12.8514L12.8514 25.2263H9.80406C7.15468 25.2263 4.99924 23.062 4.99924 20.4016C4.99924 17.7413 7.15468 15.577 9.80406 15.577C12.4534 15.577 14.609 17.7413 14.609 20.4016V33H17.3903L17.3903 20.4016C17.3903 17.7413 19.5458 15.577 22.1952 15.577C24.8445 15.577 27 17.7413 27 20.4016C27 23.062 24.8445 25.2263 22.1952 25.2263H19.1478L19.1478 28.0192H22.1952C26.3782 28.0192 29.7815 24.602 29.7815 20.4016C29.7815 16.4345 26.7453 13.1664 22.8838 12.8159Z"
        fill="#00ADEF"
      />
      <path
        d="M8.86063 42.097C8.86063 43.4912 7.7106 44.6252 6.29711 44.6252C4.88351 44.6252 3.73348 43.4912 3.73348 42.097C3.73348 40.7029 4.88351 39.5688 6.29711 39.5688C7.7106 39.5688 8.86063 40.7029 8.86063 42.097ZM8.87059 37.7626V38.5374C8.12222 38.0107 7.21898 37.7234 6.29711 37.7234C3.85175 37.7234 1.8623 39.6854 1.8623 42.097C1.8623 44.5087 3.85175 46.4707 6.29711 46.4707C7.21898 46.4707 8.12222 46.1833 8.87059 45.6567V46.4314H10.7318L10.7318 37.7626H8.87059Z"
        fill="#F3A517"
      />
      <path d="M25.7129 35V36.4224H30.1373V35L25.7129 35Z" fill="#F3A517" />
      <path
        d="M28.2611 42.097C28.2611 43.4912 27.1111 44.6252 25.6976 44.6252C24.284 44.6252 23.134 43.4912 23.134 42.097C23.134 40.7029 24.284 39.5688 25.6976 39.5688C27.1111 39.5688 28.2611 40.7029 28.2611 42.097ZM28.2711 37.7626V38.5374C27.5227 38.0107 26.6195 37.7234 25.6976 37.7234C23.2522 37.7234 21.2628 39.6854 21.2628 42.097C21.2628 44.5087 23.2522 46.4707 25.6976 46.4707C26.6195 46.4707 27.5227 46.1833 28.2711 45.6567V46.4314H30.1323V37.7626H28.2711Z"
        fill="#F3A517"
      />
      <path
        d="M16.2268 37.7234C15.3094 37.7234 14.4097 38.0082 13.6633 38.5304V37.7626H11.792V50H13.6633V42.0949C13.6645 40.702 14.8144 39.5688 16.2268 39.5688C17.6404 39.5688 18.7905 40.703 18.7905 42.0971C18.7905 43.4911 17.6404 44.6252 16.2268 44.6252H14.6948V46.4707H16.2268C18.6722 46.4707 20.6616 44.5087 20.6616 42.0971C20.6616 39.6854 18.6722 37.7234 16.2268 37.7234Z"
        fill="#F3A517"
      />
    </svg>
  );
};
